import { css } from 'lit-element';
import { DwSwitch } from '@dreamworld/dw-switch/dw-switch';
export class KerikaSwitch extends DwSwitch {
  static get styles() {
    return [
      DwSwitch.styles,
      css`
        .mdc-switch__track{
          width: 38px;
          height: 24px;
          border-radius: 12px;
          opacity: var(--mdc-switch-track-opacity, 0.38);
        }

        .mdc-switch.mdc-switch--disabled.mdc-switch--checked .mdc-switch__track {
          background-color: var(--mdc-theme-on-surface, #000);
          opacity: var(--mdc-switch-track-opacity, 0.38);
        }

        .mdc-switch.mdc-switch--checked .mdc-switch__track {
          background-color: var(--secondary-color);
          opacity: 1;
          border: none;
        }

        .mdc-switch__thumb-underlay{
          top: -12px;
          left: -14px;
        }


        .mdc-switch--checked .mdc-switch__thumb-underlay{
          left: -12px;
        }

        .mdc-switch__thumb{
          width: 14px;
          height: 14px;
          border-width: 7px;
        }

        .mdc-switch.mdc-switch--checked .mdc-switch__thumb {
          background-color: var(--primary-background-color);
          border-color: var(--primary-background-color);
        }

        mwc-ripple {
          display: none;
        }
        
      `
    ]
  }
}

customElements.define('kerika-switch', KerikaSwitch);
